var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNudgesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 12.375H5C2.5 12.375 1.25 11.75 1.25 8.625V5.5C1.25 3 2.5 1.75 5 1.75H10C12.5 1.75 13.75 3 13.75 5.5V8.625C13.75 11.125 12.5 12.375 10 12.375H9.6875C9.49375 12.375 9.30625 12.4687 9.1875 12.625L8.25 13.875C7.8375 14.425 7.1625 14.425 6.75 13.875L5.8125 12.625C5.7125 12.4875 5.48125 12.375 5.3125 12.375Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 5.5H10.625",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 8.625H8.125",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNudgesActive);
export default __webpack_public_path__ + "static/media/nudges-active.5224205712e3cf7c387a1134c9bbd4d1.svg";
export { ForwardRef as ReactComponent };